import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const ArrowLeft = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.74119 12.0354C5.98063 12.2714 6.36611 12.2687 6.60217 12.0292C6.83822 11.7898 6.83548 11.4043 6.59603 11.1683L3.99981 8.60878H13.3912C13.7274 8.60878 14 8.3362 14 7.99996C14 7.66372 13.7274 7.39114 13.3912 7.39114H4.01617L6.59739 4.8304C6.83609 4.59359 6.83763 4.20811 6.60082 3.9694C6.36401 3.7307 5.97853 3.72917 5.73983 3.96598L2.23765 7.44037C1.92008 7.75542 1.92089 8.26913 2.23944 8.58318L5.74119 12.0354Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ArrowLeft;
